import { render, staticRenderFns } from "./PcMenuButton.vue?vue&type=template&id=c596eed4"
import script from "./PcMenuButton.vue?vue&type=script&lang=js"
export * from "./PcMenuButton.vue?vue&type=script&lang=js"
import style0 from "./PcMenuButton.vue?vue&type=style&index=0&id=c596eed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VListItemAction,VListItemTitle,VMenu})
